/**
 * SystemSpecs — elegant definition list of 7 categories x N bullets.
 * Each category is a gold-hairline row; bullets use tabular figures.
 */
const ORDER = [
    "Lighting",
    "Climate",
    "Audio",
    "Video",
    "Security",
    "Networking",
    "Control",
];

export default function SystemSpecs({ specs }) {
    return (
        <div
            className="border border-[rgba(201,168,106,0.2)] bg-[#15161A]"
            data-testid="private-system-specs"
        >
            <dl>
                {ORDER.map((category, idx) => {
                    const rows = specs?.[category] || [];
                    if (rows.length === 0) return null;
                    return (
                        <div
                            key={category}
                            className={`grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-10 px-6 md:px-10 py-7 md:py-8 ${
                                idx === 0
                                    ? ""
                                    : "border-t border-[rgba(201,168,106,0.12)]"
                            }`}
                            data-testid={`private-spec-${category.toLowerCase()}`}
                        >
                            <dt className="md:col-span-3 text-[10.5px] tracking-[0.32em] uppercase text-[#C9A86A] pt-1">
                                {category}
                            </dt>
                            <dd className="md:col-span-9">
                                <ul className="space-y-3">
                                    {rows.map((line, i) => (
                                        <li
                                            key={`${category}-${line.slice(0, 40)}`}
                                            className="flex gap-3 text-[#F3EFE7] text-[15px] leading-[1.7]"
                                        >
                                            <span
                                                aria-hidden="true"
                                                className="text-[#C9A86A] select-none mt-[7px] inline-block w-3 shrink-0"
                                            >
                                                —
                                            </span>
                                            <span>{line}</span>
                                        </li>
                                    ))}
                                </ul>
                            </dd>
                        </div>
                    );
                })}
            </dl>
        </div>
    );
}
